import { SignInForm } from 'fragments/Auth/SignInForm'
import { GetStaticPropsContext, NextPage } from 'next'
import { Layout, withLayoutProps } from 'slices/Layout'

import { BaseSeo } from '@/components/seo/BaseSeo'
import { pxToRem } from '@/shared/styles/themes'
import { Container, Paper, styled } from '@mui/material'

type LoginPageProps = {
  //
}
export const getStaticProps = async (context: GetStaticPropsContext) =>
  // Pull Layout information from the core graphql server (footer, navbar, settings)
  withLayoutProps(context, {
    props: {},
  })


const Login: NextPage<LoginPageProps> = ({ ...layoutProps }) => {
  return (
    <Layout {...layoutProps} noCategoryBrowser noFooter>
      <BaseSeo />
      <Container maxWidth="sm" sx={{ display: 'flex', justifyContent: 'center' }}>
        <StyledPaper elevation={0}>
          <SignInForm />
        </StyledPaper>
      </Container>
    </Layout>
  )
}

const StyledPaper = styled(Paper)`
  border-radius: ${pxToRem(24)};
  border: 1px solid ${props => props.theme.palette.divider};
  padding: ${pxToRem(24)};
  margin-top: ${pxToRem(24)};
  margin-bottom: ${pxToRem(24)};
  max-width: ${pxToRem(400)};

  ${props => props.theme.breakpoints.up('sm')} {
    width: ${pxToRem(400)};
  }
`

export default Login
